import FormBtn from "app/Components/CommanComponents/FormBtn";

import { useTraining } from "app/_helpers/hooks";

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import ViewBasicDetailsComponent from "./Component/ViewBasicDetailsComponent";
// import { employeeFormLabel } from "./Constant";
import toastr from "toastr";
// import TrainingForm from "./Component/TrainingForm";
// import TrainingHistoryList from "./Component/TrainingHistoryList";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import {
  TRAINING_STATUS,
  TRAINING_STATUS_VIEW,
} from "app/_pages/_healthSafetyEnvironment/TrainingManagement/CONSTANTS";
import {
  getContractorPersonById,
  updateContractorPersonDesignation,
} from "app/_services/UserManagement/ContractorPersonService";
import TrainingHistoryList from "../Employee/Component/TrainingHistoryList";
import TrainingForm from "../Employee/Component/TrainingForm";
import {
  WidgetBox,
  employeeFormLabel,
  employeeTrainingEligibilityObj,
} from "../Employee/Constant";
import { ContractorPersonActions } from "./Constant";

function ContractorPersonTrainingForm() {
  const [, trainingOption] = useTraining("filter[type]=training");
  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  // const { push } = useHistory();
  const { id } = useParams();
  const [siteList, setSiteList] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [initialForm, setInitialForm] = useState({});
  const [isActive, setIsActive] = useState(false);
  const history = useHistory();
  const getFormData = useCallback(async () => {
    getContractorPersonById(id).then((response) => {
      if (!response?.status) {
        history.push("/user-management/contractor-person");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;
      const row = response.data;

      setForm({
        ...row,
        siteType: row?.ehsSite?.siteType || "",
      });

      setInitialForm({
        ...row,
        siteType: row?.ehsSite?.siteType || "",
      });

      setHistoryList(
        (row?.employeeTrainingHistory || []).map((d, i) => ({
          ...d,
          sid: i + 1,
          siteName: d?.ehsSiteForHistory?.name,
          createdAtView: d.createdAt ? DDMMYYYYFormat(d.createdAt) : "",
          trainingDesignationName: d?.newBasicTrainingDesignationData?.name,
          trainingEligibility: d?.isTrainingAssined ? "YES" : "NO",

          trainingDueDateView: d?.trainingAssigneeData?.dueDate
            ? DDMMYYYYFormat(d?.trainingAssigneeData?.dueDate)
            : "",
          trainingStatusView:
            d?.trainingAssigneeData?.deleted === 1
              ? "Deleted"
              : TRAINING_STATUS_VIEW[d?.trainingAssigneeData?.trainingStatus],

          editFlag: d?.trainingAssigneeData?.deleted !== 1 && !d?.endDate ? true : false,
        }))
      );
    });
  }, [id]);

  const getAllSiteList = useCallback(async () => {
    let response = await getAllSites("filter[status]=1");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  }, []);

  const onChange = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};

    if (+initialForm?.trainingDesignation === +form?.trainingDesignation)
      extraToChange.effectiveDate = "";

    setForm((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const effectiveDateFlag = useMemo(
    () =>
      form?.trainingDesignation &&
      +initialForm?.trainingDesignation !== +form?.trainingDesignation,
    [form?.trainingDesignation, initialForm?.trainingDesignation]
  );

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      let errorObj = {};

      if (!form.trainingEligibility)
        errorObj["trainingEligibility"] =
          employeeFormLabel["trainingEligibility"] + " is Required.";

      if (!form.trainingDesignation)
        errorObj["trainingDesignation"] =
          employeeFormLabel["trainingDesignation"] + " is Required.";

      if (effectiveDateFlag && !form?.effectiveDate) {
        errorObj["effectiveDate"] = employeeFormLabel["effectiveDate"] + " is Required.";
      }

      setError(errorObj);

      if (Object.values(errorObj).filter((d) => d !== "").length) return;

      let formObj = JSON.parse(JSON.stringify(form));
      formObj.trainingType = 2;

      if (effectiveDateFlag) formObj.effectiveDate = form?.effectiveDate;

      let response = await updateContractorPersonDesignation(id, {
        employee: formObj,
      });
      if (!response?.status) return toastr.error(response?.message);

      toastr.success(response.message || "Success.");
      // push(`/user-management/employee`);
      getFormData();
    },
    [effectiveDateFlag, form, getFormData, id]
  );

  useEffect(() => {
    getAllSiteList();
  }, [getAllSiteList]);

  useEffect(() => {
    if (!id) return;

    getFormData();
  }, [getFormData, id]);

  return (
    <div>
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title justify-content-between">
            <h3 class="text-capitalize mb-1">Change Training Designation</h3>
            <ContractorPersonActions id={id} form={form} />
          </Card.Title>
          <WidgetBox form={form} />

          <ViewBasicDetailsComponent form={form} />
          <h5 className="highlighted-text">Current Training Designation details</h5>
          <Row>
            <Col md={4}>
              <h5>{employeeFormLabel["trainingEligibility"]}</h5>
              <p>{employeeTrainingEligibilityObj[initialForm?.trainingEligibility]}</p>
            </Col>
            <Col md={4}>
              <h5>{employeeFormLabel["trainingDesignation"]}</h5>
              <p>{initialForm?.trainingDesignationData?.name}</p>
            </Col>
          </Row>

          {isActive ? (
            <>
              <h5>New Training Designation details</h5>

              <TrainingForm
                form={form}
                onChange={onChange}
                error={error}
                trainingOption={trainingOption}
                effectiveDateFlag={effectiveDateFlag}
              />

              <FormBtn
                id={id}
                backBtnTitle={"Cancel"}
                onSubmit={onSubmit}
                backOnClick={() => setIsActive(false)}
              />
            </>
          ) : (
            <div className={"mt-4 text-center"}>
              <Button onClick={history.goBack} variant="secondary" className="mr-2">
                {"Back"}
              </Button>

              <Button
                onClick={() => setIsActive(true)}
                variant="primary"
                className="ml-2"
              >
                {"Change Training Designation"}
              </Button>
            </div>
          )}

          <TrainingHistoryList
            data={historyList}
            getFormData={getFormData}
            siteList={siteList}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default ContractorPersonTrainingForm;
